import copyToClipboardFn from 'copy-to-clipboard';

export const copyToClipboard = copyToClipboardFn;
